import React from "react";
import { Link } from "react-router-dom";

const faqs = [
  {
    q: "How do I book an event?",
    a: "Request a free quote with your date, guest count, and location — we'll come back with a per-guest price and what's included. No payment or commitment at that stage.",
  },
  {
    q: "What areas do you serve?",
    a: "We're serving Chennai and surrounding areas for our Phase 1 birthday launch. More cities will follow as we expand beyond birthdays.",
  },
  {
    q: "How is pricing worked out?",
    a: "Each package is priced per guest, so your total scales with party size. The exact quote depends on guest count, location, and any customization — the numbers on our Packages page are a starting guide.",
  },
  {
    q: "Can I customize a package?",
    a: "Yes. Request a quote and mention what you'd like changed — our team will work out a customized quote around it.",
  },
  {
    q: "Do you handle setup and on-site coordination?",
    a: "Right now, Nirkana curates your decor, cake, and catering from verified partners and delivers them ready for your celebration. Full on-site event coordination is on our roadmap as we grow beyond Phase 1.",
  },
  {
    q: "How far in advance should I book?",
    a: "We'd recommend requesting your quote at least one to two weeks before your event date, especially for larger guest counts, so we have time to line up partners properly.",
  },
  {
    q: "What if I need to reschedule or cancel?",
    a: "Reach out as early as possible over WhatsApp or email — we'll work with you and our partners to find the best option for your situation.",
  },
  {
    q: "Is Nirkana connected to ONDC?",
    a: "Yes — Nirkana operates as a partner on the Open Network for Digital Commerce (ONDC), so what we coordinate can be discovered through a wider, open network rather than one closed app. See our Partners page for more.",
  },
];

const Faq = () => {
  return (
    <section className="bg-paper py-16 lg:py-24">
      <div className="max-w-content mx-auto px-6 lg:px-10">
        <div className="max-w-prose">
          <h1 className="text-3xl font-bold text-brand sm:text-4xl">Frequently asked questions</h1>
          <p className="mt-4 text-muted">
            Common questions about booking and planning with Nirkana. Don't
            see yours?{" "}
            <Link to="/contact" className="font-medium text-action hover:underline">
              Contact us
            </Link>
            .
          </p>
        </div>

        <div className="mt-12 max-w-prose space-y-8">
          {faqs.map((item) => (
            <div key={item.q} className="border-t border-line pt-6">
              <h3 className="font-semibold text-charcoal">{item.q}</h3>
              <p className="mt-2 text-sm text-muted">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
